import { render, staticRenderFns } from "./downModels.vue?vue&type=template&id=16d55b14&scoped=true&"
import script from "./downModels.vue?vue&type=script&lang=ts&"
export * from "./downModels.vue?vue&type=script&lang=ts&"
import style0 from "./downModels.vue?vue&type=style&index=0&id=16d55b14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d55b14",
  null
  
)

export default component.exports